<template lang="pug">
  section#Hello
    hgroup.landing
      h1.u-visually--hidden I am Jorge Moliner, a freelance developer and UX/UI coder passionate about web technologies.
      h1.landing__content
        p Hello —
          |  I am
          strong.me  Jorge Moliner
          | ,
        p front-end
          strong  developer
          span  &amp;
          strong  UX/UI
          |  coder
        p passionate about
          span.underline web
          | technologies
      div.landing__box
        h2
          span Web &amp;
          span App

    hr.draw-hr(v-in-viewport.once="true")
</template>

<script>
  export default {
    name: 'SectionHello',

    methods: {
      // Scroll It! - for the User Experience, lul
      hideScrollTip () {
        if (window.scrollY >= 65) {
          document.getElementById('Hello').classList.add('hidden-scrolltip')
        } else {
          document.getElementById('Hello').classList.remove('hidden-scrolltip')
        }
      }
    },

    created () {
      window.addEventListener('scroll', this.hideScrollTip)
    },

    destroyed () {
      window.removeEventListener('scroll', this.hideScrollTip)
    }

  }
</script>

<style lang="sass" scoped>
  #Hello
    min-height: 100vh
    margin-bottom: 70px
    &:after
      opacity: 0
      content: 'skills ▼'
      position: absolute
      left: 50%
      transform: translate3d(-50%,-50%,0)
      bottom: 0
      width: 4.5em
      line-height: 1.4
      text-align: center
      font-size: 0.55em
      text-transform: uppercase
      text-indent: 2px
      animation: 1s floating 2000ms ease-in-out infinite, 1s fadeIn ease-in-out 2000ms

    .landing
      text-align: center
      // H1
      &__content
        position: absolute
        width: calc(100% - 2rem)
        top: 50%
        left: 50%
        transform: translate3d(-50%,-50%,0)
        margin-top: -.7rem
        animation: .9s fadeInUp 750ms both
        // Responsive
        +breakpoint(sm)
          margin-top: .3rem
        +breakpoint(md)
          margin-top: .95rem
        +breakpoint(xl)
          margin-top: 1.85rem

        .me
          font-weight: 600
          font-size: 120%

        > p
          font-weight: 200
          font-size: 1rem
          line-height: 1.4
          color: $VeryLightGray
          &:first-child
            line-height: 1.2
          // Responsive
          +breakpoint(sm)
            font-size: 1.6rem
          +breakpoint(md)
            font-size: 2.3rem
          +breakpoint(lg)
            font-size: 2.7rem
            line-height: 1.3
          +breakpoint(xl)
            font-size: 3rem
          // '&'
          &:nth-child(2) span
            margin-right: 0.1em
            font-weight: 300
            color: $darkblue
            font-size: 106%
            line-height: 1
          // 'developer' + 'UX/UI'
          &:nth-child(2) strong
            font-weight: 500
            color: #f2f2f2
            &:last-child
              font-size: 88%

      // H2
      &__box
        z-index: -1
        position: absolute
        top: 50%
        left: 50%
        transform: translate3d(-50%,-33.33333%,0)
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        h2
          position: relative
          color: rgba(12, 12, 27, .45)
          font-size: 5.6rem
          font-weight: 600
          line-height: .9
          margin-top: -.8em
          padding: .2em 0 .3em
          white-space: nowrap
          overflow: hidden
          backface-visibility: hidden
          span
            display: block
            +unselectable
            // Responsive
            +breakpoint(sm)
              font-size: 9.3rem
            +breakpoint(md)
              font-size: 11.5625rem
            +breakpoint(lg)
              font-size: 13.5625rem
            +breakpoint(xl)
              font-size: 15.5625rem


    // noob line effect
    .draw-hr
      position: absolute
      bottom: 0
      left: calc(50% - 1px)
      opacity: 0
      background-color: #fff
      pointer-events: none
      &.in-viewport
        transform: translateY(1.25rem)
        animation: draw-hr 1.25s
        animation-direction: reverse
        transition: opacity 1s ease-in-out
      @keyframes draw-hr
        from
          opacity: 1
          height: 0
          width: 1px
        to
          height: 4.75rem
          width: 1px
</style>



<!-- Zig Zag Underline CSS effect (https://codepen.io/moritzjacobs/pen/xqomVY) -->
<style lang="scss">
/// Helper function to easily use an SVG inline in CSS
/// without encoding it to base64, saving bytes.
/// It also helps with browser support.

/// A small function allowing skipping base64 encoding
/// and simply pasting the SVG markup right in the CSS.
/// @author Jakob Eriksen
/// @link https://codepen.io/jakob-e/pen/doMoML
/// @param {String} $svg - SVG image to encode
/// @return {String} - Encoded SVG data uri
@function svg-uri($svg) {
  $encoded: '';
  $slice: 2000;
  $index: 0;
  $loops: ceil(str-length($svg) / $slice);

  @for $i from 1 through $loops {
    $chunk: str-slice($svg, $index, $index + $slice - 1);
    $chunk: str-replace($chunk, '"', "'");
    $chunk: str-replace($chunk, '<', '%3C');
    $chunk: str-replace($chunk, '>', '%3E');
    $chunk: str-replace($chunk, '&', '%26');
    $chunk: str-replace($chunk, '#', '%23');
    $encoded: #{$encoded}#{$chunk};
    $index: $index + $slice;
  }

  @return url("data:image/svg+xml;charset=utf8,#{$encoded}");
}
/// Replace `$search` with `$replace` in `$string`
/// @author Hugo Giraudel
/// @link http://sassmeister.com/gist/1b4f2da5527830088e4d
/// @param {String} $string - Initial string
/// @param {String} $search - Substring to replace
/// @param {String} $replace ('') - New value
/// @return {String} - Updated string
@function str-replace($string, $search, $replace: '') {
  $index: str-index($string, $search);

  @if $index {
    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);
  }

  @return $string;
}

// Sass Mixin
@mixin animated-underline($color:rgba(0, 50, 102, .65), $width:1.4em, $time:2s) {
	$h: $width / 2;
	$svg: '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 100" xml:space="preserve"><polyline fill="none" stroke="'+$color+'" stroke-width="'+$width+'" stroke-miterlimit="10" points="-45.004,5 4.995,55 5,55 55,105 105,55 105.005,55 155.005,5 205.005,55 205.01,55 255.01,105 "/></svg>';

	display: inline-block;
	position: relative;
	&:before {
    z-index:-1;
		content: "";
		position: absolute;
		bottom: 4px;
		left: 0;
		transform: translateY(90%);
		height: $h;
		width: 100%;
		background-image: svg-uri($svg);
		background-position: 0 center;
		background-repeat: repeat-x;
		background-size: auto 100%;
		animation: bg-slide $time infinite linear;
		@keyframes bg-slide {
			0% {
				background-position: 0 center;
			}
			100% {
				background-position: $h center;
			}
		}
	}
}
// Just do it for your kikirilövah
.underline {
  @include animated-underline;
    margin: 0 .75rem;
    text-shadow: 1px 1px rgba(0,0,0,.3);
    position: relative;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/SectionHello.vue